module.exports = "https://www.gc-qa.gnp.com.mx/8e2c7c9abb665846afd899b088bd3fa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/documentos-icono.svg
// module id = 966
// module chunks = 0